import React, { Component } from 'react'
import { connect } from 'react-redux'

import Button from '@mui/material/Button'
import ListItem from '@mui/material/ListItem'

import { reAuthUser, loginUser, logoutUser, toggleLoginDialog, updateUserInfo } from '../redux/actions/authActions'
import LoginDialog from '../components/dialogs/LoginDialog';
import UserAvatar from './UserAvatar'
import Divider from '@mui/material/Divider';
//import UserDialog from '../components/dialogs/UserDialog'

import api from "../utils/HistApi";
import { showDialog, showFeedback } from '../redux/actions/MainDialog';

import ReactGA from 'react-ga4'
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ProfileIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
import NotificationsIcon from '@mui/icons-material/Notifications';
import SwitchIcon from '@mui/icons-material/SwapHoriz';
import LogOutIcon from 'mdi-material-ui/Logout'
import ReportIcon from '@mui/icons-material/Report';
import TemplatesIcon from '@mui/icons-material/Description';
import FeedbackIcon from '@mui/icons-material/Feedback';
import PaymentIcon from '@mui/icons-material/Payment';
import PostJobIcon from 'mdi-material-ui/BriefcasePlus'
import BookmarksIcon from '@mui/icons-material/Bookmarks';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import RateReviewIcon from '@mui/icons-material/RateReview';
import PeopleIcon from '@mui/icons-material/People';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import { postNewJob } from '../redux/actions/selectedJob';
import { getRedirectPath } from '../utils/utils'
import { IconButton, List, Popover } from '@mui/material'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import AssignmentIcon from '@mui/icons-material/Assignment';
//import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import ListIcon from '@mui/icons-material/List';
import DateRangeIcon from '@mui/icons-material/DateRange';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { push } from '../components/routerPatch'


class UserNav extends Component {
    state = {
        anchorEl: null,
        menmuIndex: 0
    };

    constructor(props) {
        super(props);

        if (!props.isAuthed){
            const searchParams = new URLSearchParams(window.location.search);

            if (searchParams.get("login")){
                this.showLoginDialog()
            }
        }
        
        this.showMessage = this.showMessage.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
    }

    componentDidMount() {
        const { dispatch } = this.props
        dispatch(reAuthUser());
    }
    
    handleMenu = event => {
        this.setState({ anchorEl: event.currentTarget });
    };
    
    handleMenuClose = () => {
        this.setState({ anchorEl: null });
    };    
    
    showLoginDialog = () => {
        const { dispatch } = this.props
        dispatch(toggleLoginDialog(true))
    };
    
    handleSetSection = section => {
        const { dispatch } = this.props
        dispatch(toggleLoginDialog(true, section))
    }

	closeLoginDialog = () => {
        const { dispatch } = this.props
        dispatch(toggleLoginDialog(false))
    };

    showMessage = (title, content) => {
        const { dispatch } = this.props
        dispatch(showDialog(title, content))
    }

    handleFeedback = () => {
        const { dispatch } = this.props
        dispatch(showFeedback())
        this.handleMenuClose();
    }

    handleLogin = (payload) => {
        this.props.dispatch(
            loginUser(payload, () => {
                //this.closeLoginDialog();
                //this.clearForm();
                /*const { from } = this.props.location.state || {
                    from: { pathname: "/profile" }
                };
                this.props.history.push(from.pathname);*/
            })
        );
    }

    handleLogOut = () => {
        const { dispatch } = this.props
        dispatch(logoutUser(()=>{
            this.setState({ anchorEl: null });
        }));
    }

    handletoProfile = () => {
        this.setState({ anchorEl: null });
        
        const { dispatch } = this.props
        dispatch(push('/profile'));
    }

    handletoSettings = () => {
        this.setState({ anchorEl: null });
        
        const { dispatch } = this.props
        dispatch(push('/settings'));
    }

    onMenuItemClicked = (location) => {    
        this.setState({ anchorEl: null });

        const { dispatch } = this.props
        dispatch(push('/' + location));
    }

    handleChangeRole = (lookingforwork) => {
        if (lookingforwork){
            ReactGA.event({category: 'User',action: 'became_jobseeker'});
        } else {
            ReactGA.event({category: 'User',action: 'became_recruiter'});
        }

        this.setState({ anchorEl: null });
        let fieldsToUpdate = {};

        fieldsToUpdate.lookingforwork = lookingforwork;

        api.saveProfile(fieldsToUpdate, (result)=>{
            const { dispatch } = this.props
            dispatch(updateUserInfo({userInfo: result.userData, applies: result.applies}));
            dispatch(push('/'));
        })
    }

    handlePostNewJob = () => {
        this.setState({ anchorEl: null });
        this.props.dispatch(postNewJob())
    }

    handleNextchangeMenu = newMenuIndex => () => {
        this.setState({ menmuIndex: newMenuIndex });
    }


    render() {
        const isJobHunt = this.props.isJobHunt || false
        const { isAuthed, userInfo, loginErrors, openDialog, isFetching, loginChecked, histogramType, section, isJHUser } = this.props

        const isAdmin = (isAuthed && userInfo.isAdmin)
        const isJHAdmin = (isAuthed && userInfo.isJHAdmin)
        const isPro = (isAuthed && userInfo.isPro)
        const avatarSrc = (userInfo.avatar && userInfo.avatar.url) ? userInfo.avatar.url : undefined

        const { anchorEl, menmuIndex } = this.state;
        const open = Boolean(anchorEl);

        const view = (window.innerWidth <= 768)?'MOBILE':'DESKTOP'

        let menus = []

        if (isJHAdmin || isAdmin){
            menus.push({label:'JobHunt', id: 0})
        }
        if (isAdmin){
            menus.push({label:'JobSwipe', id: 1})
        }
        menus.push({label:'Regular', id: 2})

        const validMenuIndex = (menmuIndex>menus.length-1) ? 0 : menmuIndex

        const menu = menus[validMenuIndex] || {}
        const menuId = menu.id

        return (
            <>
                {<React.Fragment>
                    {(isAuthed) ? 
                    <React.Fragment>
                        <UserAvatar onClick={this.handleMenu} 
                            firstName={userInfo.first_name} 
                            lastName={userInfo.last_name} 
                            name={userInfo.name} 
                            avatarSrc={avatarSrc} 
                            backgroundColor={userInfo.card_color} 
                            header
                            pro={isPro}/>
                        <Popover
                            open={open}
                            anchorEl={anchorEl}
                            onClose={this.handleMenuClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            classes={{ paper: "userMenu" }}  
                        >
                            {(view==='MOBILE' && menus.length>1)&&<ListItem style={{justifyContent: 'space-between'}}>
                                <IconButton
                                    disabled={isFetching || validMenuIndex===menus.length-1}
                                    color='primary'
                                    onClick={this.handleNextchangeMenu(validMenuIndex+1)}
                                    aria-label="cancel"
                                    size="large">
                                    <ChevronLeftIcon/>
                                </IconButton>
                                <IconButton
                                    disabled={isFetching || validMenuIndex===0}
                                    color='primary'
                                    onClick={this.handleNextchangeMenu(validMenuIndex-1)}
                                    aria-label="cancel"
                                    size="large">
                                    <ChevronRightIcon/>
                                </IconButton>
                            </ListItem>}
                            {((isJHAdmin || isAdmin)&&(view==='DESKTOP' || menuId===0))&&<List component="nav" style={{background:"linear-gradient(#f8ebfe, #fefeff, #f8ebfe)"}}>
                                <ListItem button onClick={() => this.onMenuItemClicked('jobhunt-users')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <PeopleIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="JobHunt Users"/>
                                </ListItem>
                                <ListItem button onClick={() => this.onMenuItemClicked('jobhunt-settings')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <SettingsIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="JobHunt Settings"/>
                                </ListItem>
                                <ListItem button onClick={() => this.onMenuItemClicked('jobhunt-reviews')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <RateReviewIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="JobHunt Reviews"/>
                                </ListItem>
                                <ListItem button onClick={() => this.onMenuItemClicked('marketing-posts')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <ListIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Marketing Posts"/>
                                </ListItem>
                                <ListItem button onClick={() => this.onMenuItemClicked('marketing-calendar')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <DateRangeIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Marketing Calendar"/>
                                </ListItem>
                                <ListItem button onClick={() => this.onMenuItemClicked('marketing-dashboard')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <DashboardIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Marketing Dashboard"/>
                                </ListItem>
                                <ListItem button onClick={() => this.onMenuItemClicked('templates')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <TemplatesIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Email Templates"/>
                                </ListItem>
                                {/*(<ListItem button onClick={() => this.onMenuItemClicked('jobhunt-payment')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <PaymentIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Payment Link"/>
                                </ListItem>*/}
                                <ListItem button onClick={() => this.onMenuItemClicked('jobhunt-statistics')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <EqualizerIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Statistics"/>
                                </ListItem>
                                <ListItem button onClick={() => this.onMenuItemClicked('jobhunt-publishes')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <TemplatesIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Publish List"/>
                                </ListItem>
                                <ListItem button onClick={() => this.onMenuItemClicked('questionnaires')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <AssignmentIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Questionnaires"/>
                                </ListItem>
                                <ListItem button onClick={() => this.onMenuItemClicked('leads')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <ContactPhoneIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Leads"/>
                                </ListItem>
                                <ListItem button onClick={() => this.onMenuItemClicked('jobhunt-clients-status')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <PeopleIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Clients List"/>
                                </ListItem>
                                <ListItem button onClick={() => this.onMenuItemClicked('jobs-found')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <PeopleIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Jobs Found"/>
                                </ListItem>
                                <ListItem button onClick={() => this.onMenuItemClicked('interviews-report')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <AssignmentIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Interviews"/>
                                </ListItem>
                                {/*<ListItem button onClick={() => this.onMenuItemClicked('synamediaClients')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <PeopleIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Synamedia"/>
                                </ListItem>
                                <ListItem button onClick={() => this.onMenuItemClicked('bflClients')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <PeopleIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Bfl"/>
                                </ListItem>*/}
                                <ListItem button onClick={() => window.open('https://business.jobhunt.co.il', '_blank')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <PeopleIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="B2B"/>
                                </ListItem>
                                {/*<ListItem button onClick={() => this.onMenuItemClicked('events/JobHunt-Webinar')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <PeopleIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Webinars"/>
                                </ListItem>*/}
                            </List>}
                            {(isAdmin&&(view==='DESKTOP' || menuId===1))&&<List component="nav" style={{background: 'linear-gradient(rgb(232 240 254), rgb(254, 254, 255), rgb(232 240 254))'}}>
                                {(isAdmin)&&<ListItem button onClick={() => this.onMenuItemClicked('reports')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <ReportIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Reports"/>
                                </ListItem>}
                                {(isAdmin)&&<ListItem button onClick={() => this.onMenuItemClicked('users')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <PeopleIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Users"/>
                                </ListItem>}
                                {(isAdmin)&&<ListItem button onClick={() => this.onMenuItemClicked('payments')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <PaymentIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Payments"/>
                                </ListItem>}
                                {(isAdmin)&&<ListItem button onClick={() => this.onMenuItemClicked('sendpushnotifications')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <PhoneAndroidIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Send Push"/>
                                </ListItem>}
                                {(isAdmin)&&<ListItem button onClick={() => this.onMenuItemClicked('jssettings')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <SettingsIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Settings"/>
                                </ListItem>}
                            </List>}
                            {(view==='DESKTOP' || menuId===2)&&<List component="nav">
                                {(isJHUser)&&<ListItem button onClick={() => this.onMenuItemClicked('personal-journey')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <PermContactCalendarIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Personal Journey"/>
                                </ListItem>}
                                {(!isJobHunt)&&<ListItem button onClick={() => this.onMenuItemClicked('profile')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <ProfileIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Profile"/>
                                </ListItem>}
                                {/*isJobHunt&&<ListItem button onClick={() => window.location.href = 'https://jobswipe.co/profile?login=true'} disabled={isFetching}>
                                    <ListItemIcon>
                                        <ExitToAppIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="JobSwipe"/>
                                </ListItem>*/}
                                {(!isJobHunt)&&<ListItem button onClick={() => this.onMenuItemClicked('settings')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <SettingsIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Settings"/>
                                </ListItem>}
                                {(!isJobHunt)&&<ListItem button onClick={() => this.onMenuItemClicked('saveditems')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <BookmarksIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Saved"/>
                                </ListItem>}
                                {(!isJobHunt)&&<ListItem button onClick={() => this.onMenuItemClicked('notifications')} disabled={isFetching}>
                                    <ListItemIcon>
                                        <NotificationsIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Alerts"/>
                                </ListItem>}
                                {(!isJobHunt)&&<Divider/>}
                                {(isAuthed&&userInfo.lookingforwork&&!isJobHunt)&&<ListItem button onClick={() => this.handleChangeRole(false)} disabled={isFetching}>
                                    <ListItemIcon>
                                        <SwitchIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Switch to recruiter"/>
                                </ListItem>}
                                {(isAuthed&&!userInfo.lookingforwork&&!isJobHunt)&&<ListItem button onClick={() => this.handleChangeRole(true)} disabled={isFetching}>
                                    <ListItemIcon>
                                        <SwitchIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Switch to candidate"/>
                                </ListItem>}
                                {(!isJobHunt)&&<Divider/>}
                                {(!isJobHunt && loginChecked && histogramType !== 'myJobs')&&
                                <ListItem button className="postNewJob" onClick={this.handlePostNewJob} disabled={isFetching}>
                                    <ListItemIcon className="icon">
                                        <PostJobIcon />
                                    </ListItemIcon>
                                    <ListItemText className="text" primary="Post jobs free"/>
                                </ListItem>}
                                {/*!isJobHunt&&<ListItem button onClick={() => window.location.href = isJHUser?'https://dashboard.jobhunt.co.il?login=true':'https://jobhunt.co.il'} disabled={isFetching}>
                                    <ListItemIcon>
                                        <ExitToAppIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Back To JobHunt"/>
                                </ListItem>*/}
                                <ListItem button onClick={() => this.handleFeedback()} disabled={isFetching}>
                                    <ListItemIcon>
                                        <FeedbackIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Submit feedback"/>
                                </ListItem>
                                <ListItem button onClick={this.handleLogOut} disabled={isFetching}>
                                    <ListItemIcon>
                                        <LogOutIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Log Out"/>
                                </ListItem>
                        </List>}
                        </Popover>
                    </React.Fragment> : 
                    <React.Fragment>
                        <LoginDialog
                            open={openDialog && loginChecked}
                            section={section}
                            onClose={this.closeLoginDialog}
                            handleLogin={this.handleLogin}
                            handleSetSection={this.handleSetSection}
                            loginErrors={loginErrors}
                            showMessage={this.showMessage}
                            redirectPath={window.location.pathname}
                            />
                        <Button style={{marginLeft:15, fontSize:'0.7rem',padding:4}} onClick={this.showLoginDialog} color="inherit" variant="outlined" aria-label="Sign In">Sign In</Button>
                    </React.Fragment>}
                </React.Fragment>}
            </>
        );
    }
}

function mapStateToProps(state) {
    const { isAuthed, userInfo, loginErrors, openDialog, loginChecked, section } = state.authUser;
    const isFetching = state.histogramJobs.isFetching
    const histogramType = state.histogramData.histogramType
    const selectedJob = state.selectedJob.job;

    const isJHUser = (userInfo && userInfo.isJHUser)

    return {
        isAuthed, userInfo, loginErrors, openDialog, isFetching, loginChecked, histogramType, section, selectedJob, isJHUser
    }
}

export default connect(mapStateToProps)(UserNav)